const axios = require('axios');
import {errorHandler} from "./common";
export function updateOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.post(process.env.ROOT_API + 'order', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
        errorHandler(error);
        reject(error);
      });
  })
}


export function queryOrders(query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'orders/query?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function queryOrdersItems(query) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'orders/items/query?' + query, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Order List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function placeOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("place Order " + localStorage.getItem("JSTOKEN"))
    console.log(order);
    axios.post(process.env.ROOT_API + 'order/place', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}

export function deleteOrder(order) {
  return new Promise(function (resolve, reject) {
    console.log("place Order " + localStorage.getItem("JSTOKEN"))
    console.log(order);
    axios.post(process.env.ROOT_API + 'order/delete', JSON.stringify(order), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Order Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js